import * as bootstrap from "bootstrap"

const initializeTooltip = (element) => {
  if (bootstrap.Tooltip.getInstance(element)) return

  new bootstrap.Tooltip(element)
}

const initializeTooltips = (container) => {
  if (container.matches?.('[data-bs-toggle="tooltip"]')) {
    initializeTooltip(container)
  }

  container
    .querySelectorAll?.('[data-bs-toggle="tooltip"]')
    .forEach(initializeTooltip)
}

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType !== Node.ELEMENT_NODE) return

      initializeTooltips(node)
    })
  })
})

document.addEventListener("turbo:load", () => {
  initializeTooltips(document)

  observer.observe(document.body, {
    childList: true,
    subtree: true
  })
})
